import { ContentPlacement } from './content.placement'

export type Placement = ContentPlacement;

export const Placement = {
  ...ContentPlacement
}
